import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
	GetExamsPreparation,
	GetExamsPreparationParams,
	GetExamsPreparationModel,
} from 'domain/usecases';

export class RemoteGetExamPreparation implements GetExamsPreparation {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamsPreparationModel>,
	) {}

	async get({signal, ...params}: GetExamsPreparationParams): Promise<GetExamsPreparationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
